const transform = res => {
  const data = res?.data?.students || [];

  return data;
};

export { transform };
